
import booleanParser from 'boolean-parser'

import { storeGet } from 'Helpers/localStorage'

import { STORE_KEY_USER_OPTIONS, STORE_KEY_ACCOUNT_OPTIONS, STORE_KEY_ACCOUNT } from 'Constants'

const evalUserOption = (optionName) => {
  const userOptions = storeGet(STORE_KEY_USER_OPTIONS) || []
  return userOptions.includes(optionName)
}

const evalAccountOption = (optionName) => {
  const accountOptions = storeGet(STORE_KEY_ACCOUNT_OPTIONS) || []
  return accountOptions.includes(optionName)
}

const evalAccountProperty = (propertyName) => {
  const account = storeGet(STORE_KEY_ACCOUNT) || {}
  return !!account[propertyName]
}

const evalConditionToken = (t) => {
  const matches = t.trim().match(/^NOT\s+(.*)$/)

  if (matches) {
    return !evalSingleCondition(matches[1])
  } else {
    return evalSingleCondition(t)
  }
}

const evalSingleCondition = (condition) => {
  const matches = condition.match(/(uo|co|c):(.*)/)

  switch (matches[1]) {
    case 'uo':
      return evalUserOption(matches[2])

    case 'co':
      return evalAccountOption(matches[2])

    case 'c':
      return evalAccountProperty(matches[2])

    default:
      return false
  }
}

const evalCondition = (condition) => {
  //  it returns an OR array of AND combination
  const booleanTokens = booleanParser.parseBooleanQuery(condition)

  const result = booleanTokens.reduce((currentValue, item) => {
    return currentValue || item.reduce((currentAndValue, conditionToken) => {
      return currentAndValue && evalConditionToken(conditionToken)
    }, true)
  }, false)

  return result
}

export default evalCondition
